export default "__VITE_ASSET__hrDsmnDP__"